// src/telas/insumos/index.tsx

import { Menu } from "../menu";
import styles from "./styles.module.css";
import { useContext, useEffect, useState } from "react";
import { AuthFetchJson, url } from "../../api";
import Swal from "sweetalert2";
import { ContextRegister } from "../../context";
import { useNavigate } from "react-router-dom";

type InsumoType = {
  B1_COD?: string;
  B1_DESC: string;
  checked?: boolean;
  Z6_CODINS?: string;
};

export function Insumos() {
  const { state } = useContext(ContextRegister);
  const navigate = useNavigate();
  const [meusInsumos, setMeusInsumos] = useState<InsumoType[]>([]);
  const [insumos, setInsumos] = useState<InsumoType[]>([]);
  const [termo, setTermo] = useState("");

  function buscarMeusInsumos() {
    AuthFetchJson(`${url}COLETAINSPARCEIRO`, {
      method: "POST",
      body: JSON.stringify({
        CODPAR: state.usuario.A2_COD,
        LOJA: state.usuario.A2_LOJA,
      }),
    })
      .then((response) => {
        if (response.sucesso !== "T") {
          Swal.fire("Erro ao buscar insumos associados.");
          return;
        }
        setMeusInsumos(response.dados);
      })
      .catch((error) => {
        Swal.fire("Erro ao buscar insumos associados.");
        console.log(error);
      })
      .finally(() => {
        if (Swal.isLoading()) Swal.close();
      });
  }

  function handleCheckIns(index: number, obj: InsumoType) {
    let aux = [...insumos];
    index = aux.findIndex((a) => a.B1_COD === obj.B1_COD);
    aux.splice(index, 1, { ...obj, checked: !obj.checked });
    setInsumos(aux);
  }

  function handleSave() {
    Swal.fire({
      title: "Salvando",
      html: "Aguarde, gravando dados de insumos",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    let insumosSave = insumos
      .filter((insumo) => insumo.checked)
      .map((insumo) => ({ CODINS: insumo.B1_COD }));

    AuthFetchJson(`${url}INSUMOPARCEIRO`, {
      method: "POST",
      body: JSON.stringify({
        CODPAR: state.usuario.A2_COD,
        LOJA: state.usuario.A2_LOJA,
        itens: insumosSave,
      }),
    }).finally(() => {
      if (Swal.isLoading()) Swal.close();
    });
  }

  useEffect(() => {
    Swal.fire({
      title: "Carregando",
      html: "Carregando insumos cadastrados",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    AuthFetchJson(`${url}COLETAINSUMO`)
      .then((response) => {
        if (response.sucesso !== "T") {
          Swal.fire("Erro ao buscar insumos");
          return;
        }
        setInsumos(
          response.dados.map((insumo: any) => ({
            B1_COD: insumo.B1_COD,
            B1_DESC: insumo.B1_DESC,
            checked: false,
          })),
        );
        buscarMeusInsumos();
      })
      .catch((error) => {
        Swal.fire("Erro ao buscar insumos");
        console.log(error);
      })
      .finally(() => {
        if (Swal.isLoading()) Swal.close();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (insumos.length === 0 || meusInsumos.length === 0) return;

    let insumosInter = insumos.map((insumo) => {
      if (meusInsumos?.some((i) => i.Z6_CODINS === insumo.B1_COD)) {
        return { ...insumo, checked: true };
      }
      return insumo;
    });

    setInsumos(insumosInter);
  }, [meusInsumos]); // eslint-disable-line react-hooks/exhaustive-deps

  const insumosFiltrados = insumos.filter(
    (insumo) =>
      insumo.B1_DESC.toUpperCase().search(`${termo}`.toUpperCase()) !== -1,
  );

  const totalSelecionados = insumos.filter((i) => i.checked).length;

  return (
    <div className={styles.container}>
      <Menu />

      <div className={styles.backContainer}>
        <p onClick={() => navigate(-1)}>{"< Voltar"}</p>
      </div>

      <div className={styles.content}>
        <div className={styles.insumoContainer}>
          <div className={styles.insumoHeader}>
            <h2>Insumos</h2>
            {totalSelecionados > 0 && (
              <span className={styles.badge}>{totalSelecionados} selecionado(s)</span>
            )}
            <button className={styles.btnSalvar} onClick={handleSave}>
              Salvar
            </button>
          </div>

          <input
            className={styles.searchInput}
            placeholder="Pesquisar insumo..."
            type="text"
            value={termo}
            onChange={(event) => setTermo(event.target.value)}
          />

          <div className={styles.insumosOverflow}>
            {insumosFiltrados.length === 0 ? (
              <p className={styles.emptyText}>Nenhum insumo encontrado.</p>
            ) : (
              insumosFiltrados.map((insumo, index) => (
                <label
                  key={insumo.B1_COD}
                  className={`${styles.insumoItem} ${insumo.checked ? styles.insumoItemChecked : ""}`}
                >
                  <input
                    type="checkbox"
                    onChange={() => handleCheckIns(index, insumo)}
                    value={insumo.B1_DESC}
                    checked={insumo.checked}
                  />
                  <span>{insumo.B1_DESC}</span>
                </label>
              ))
            )}
          </div>

          <div className={styles.listFooter}>
            <span>{insumosFiltrados.length} insumo(s)</span>
          </div>
        </div>
      </div>
    </div>
  );
}